// tslint:disable:max-line-length
import * as React from 'react';

import * as styles from './styles.css';

export const Compare = () => <div className={styles['icon']} />;
